import lazyLoad from "@loadable/component";
import createPlugin from "./createPlugin";
import ImageAndTextRenderer from "./Renderer";

const ImageAndTextForm = lazyLoad(() => import("./Form"));

const ImageAndTextPlugin = (settings) =>
    createPlugin({
        Renderer: ImageAndTextRenderer,
        Controls: ImageAndTextForm,
        ...settings,
    });

const ImageAndText = ImageAndTextPlugin();
export default ImageAndText;

export { ImageAndTextPlugin, ImageAndTextRenderer };
